import { component } from 'picoapp'
import Splide from '@splidejs/splide'

export default component((node) => {
  const sliderElement = node.querySelector('.splide')
  if (!sliderElement) return

  new Splide(sliderElement, {
    drag: true,
    gap: 8,
    pagination: false,
    arrows: true,
    perPage: 3,
    perMove: 1,
    breakpoints: {
      768: {
        perPage: 1,
      },
    },
  }).mount()
})
